import { SVGProps, Ref, forwardRef } from "react";

const FilterListIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Filter List Icon"
    {...props}
  >
    <title id="Filter List Icon">Filter List Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 12h12M3 6h18M9 18h6"
    />
  </svg>
);

const ForwardRef = forwardRef(FilterListIcon);
export default ForwardRef;
